export const dynamicTranslationRows = [
  ["{count} active", "{count} activos", "{count} ativos", "{count}件対応中"],
  [
    "{count} active cleaning will be cancelled.",
    "Se cancelará {count} limpieza activa.",
    "{count} limpeza ativa será cancelada.",
    "進行中の清掃{count}件がキャンセルされます。",
  ],
  [
    "{count} active cleanings will be cancelled.",
    "Se cancelarán {count} limpiezas activas.",
    "{count} limpezas ativas serão canceladas.",
    "進行中の清掃{count}件がキャンセルされます。",
  ],
  [
    "{count} active team",
    "{count} miembros activos",
    "{count} membros ativos",
    "有効なメンバー{count}名",
  ],
  ["{count} cleaning", "{count} limpieza", "{count} limpeza", "清掃{count}件"],
  [
    "{count} cleanings",
    "{count} limpiezas",
    "{count} limpezas",
    "清掃{count}件",
  ],
  ["{count} client", "{count} cliente", "{count} cliente", "顧客{count}件"],
  ["{count} clients", "{count} clientes", "{count} clientes", "顧客{count}件"],
  ["{count} invoice", "{count} factura", "{count} fatura", "請求書{count}件"],
  [
    "{count} invoices",
    "{count} facturas",
    "{count} faturas",
    "請求書{count}件",
  ],
  [
    "{count} schedule updates need you",
    "{count} cambios de agenda necesitan tu respuesta",
    "{count} atualizações da agenda precisam de você",
    "スケジュール更新{count}件に対応が必要です",
  ],
  [
    "{count} service",
    "{count} servicio",
    "{count} serviço",
    "サービス{count}件",
  ],
  [
    "{count} services",
    "{count} servicios",
    "{count} serviços",
    "サービス{count}件",
  ],
  [
    "{count} unpaid cleaning",
    "{count} limpieza sin pagar",
    "{count} limpeza não paga",
    "未払いの清掃{count}件",
  ],
  [
    "{count} unpaid cleanings",
    "{count} limpiezas sin pagar",
    "{count} limpezas não pagas",
    "未払いの清掃{count}件",
  ],
  [
    "{count} unread notifications",
    "{count} notificaciones sin leer",
    "{count} notificações não lidas",
    "未読通知{count}件",
  ],
  [
    "{file} is larger than 75 MB.",
    "{file} supera los 75 MB.",
    "{file} é maior que 75 MB.",
    "{file}は75 MBを超えています。",
  ],
  [
    "{file} is not a supported photo or video.",
    "{file} no es una foto o un video compatible.",
    "{file} não é uma foto ou um vídeo compatível.",
    "{file}は対応している写真または動画ではありません。",
  ],
  [
    "{identity} is not the approved Microsoft administrator account.",
    "{identity} no es la cuenta de administrador de Microsoft aprobada.",
    "{identity} não é a conta Microsoft de administrador aprovada.",
    "{identity}は承認済みのMicrosoft管理者アカウントではありません。",
  ],
  [
    "{label} copied.",
    "{label} copiado.",
    "{label} copiado.",
    "{label}をコピーしました。",
  ],
  [
    "{name} was restored to the active list.",
    "{name} volvió a la lista activa.",
    "{name} voltou para a lista ativa.",
    "{name}を有効な一覧に復元しました。",
  ],
  [
    "A valid work email is required to create an invitation.",
    "Se necesita un correo laboral válido para crear una invitación.",
    "É necessário um e-mail profissional válido para criar um convite.",
    "招待を作成するには有効な勤務先メールアドレスが必要です。",
  ],
  [
    "Account profile updated.",
    "Perfil de la cuenta actualizado.",
    "Perfil da conta atualizado.",
    "アカウントプロフィールを更新しました。",
  ],
  [
    "Add & create invite",
    "Agregar y crear invitación",
    "Adicionar e criar convite",
    "追加して招待を作成",
  ],
  [
    "Add a client first",
    "Agrega primero un cliente",
    "Adicione um cliente primeiro",
    "先に顧客を追加してください",
  ],
  [
    "Add a short explanation for the client",
    "Agrega una breve explicación para el cliente",
    "Adicione uma breve explicação para o cliente",
    "顧客向けの簡単な説明を追加",
  ],
  ["Add address", "Agregar dirección", "Adicionar endereço", "住所を追加"],
  ["Add client", "Agregar cliente", "Adicionar cliente", "顧客を追加"],
  ["Add only", "Solo agregar", "Somente adicionar", "追加のみ"],
  [
    "Address unavailable",
    "Dirección no disponible",
    "Endereço indisponível",
    "住所を利用できません",
  ],
  ["All caught up", "Todo al día", "Tudo em dia", "すべて対応済みです"],
  ["Approve", "Aprobar", "Aprovar", "承認"],
  ["Approved", "Aprobado", "Aprovado", "承認済み"],
  [
    "Archive {name}?",
    "¿Archivar a {name}?",
    "Arquivar {name}?",
    "{name}をアーカイブしますか？",
  ],
  [
    "Archived {date}",
    "Archivado el {date}",
    "Arquivado em {date}",
    "{date}にアーカイブ",
  ],
  [
    "Archived client",
    "Cliente archivado",
    "Cliente arquivado",
    "アーカイブ済み顧客",
  ],
  ["Archiving…", "Archivando…", "Arquivando…", "アーカイブ中…"],
  [
    "Ask the business owner to choose or restore the company plan. Your role and team record are still safe.",
    "Pide al propietario que elija o restaure el plan de la empresa. Tu rol y registro del equipo siguen protegidos.",
    "Peça ao proprietário para escolher ou restaurar o plano da empresa. Sua função e seu cadastro na equipe continuam seguros.",
    "会社のオーナーにプランの選択または復元を依頼してください。あなたの役割とチーム記録は保持されています。",
  ],
  [
    "Assign the team without exposing client financials.",
    "Asigna el equipo sin mostrar los datos financieros del cliente.",
    "Atribua a equipe sem expor os dados financeiros do cliente.",
    "顧客の財務情報を表示せずにチームを割り当てます。",
  ],
  [
    "Attach photos or videos",
    "Adjuntar fotos o videos",
    "Anexar fotos ou vídeos",
    "写真または動画を添付",
  ],
  [
    "Available plans",
    "Planes disponibles",
    "Planos disponíveis",
    "利用可能なプラン",
  ],
  [
    "Back to conversations",
    "Volver a las conversaciones",
    "Voltar para as conversas",
    "会話一覧に戻る",
  ],
  ["Beta trial", "Prueba beta", "Teste beta", "ベータトライアル"],
  ["Bill to", "Facturar a", "Faturar para", "請求先"],
  [
    "Build the calendar, approve company availability, and let clients confirm inside TidyPing.",
    "Organiza el calendario, aprueba la disponibilidad de la empresa y deja que los clientes confirmen dentro de TidyPing.",
    "Monte o calendário, aprove a disponibilidade da empresa e permita que os clientes confirmem dentro do TidyPing.",
    "カレンダーを作成し、会社の空き時間を承認して、顧客がTidyPing内で確認できるようにします。",
  ],
  [
    "Business logo removed.",
    "Logo de la empresa eliminado.",
    "Logo da empresa removido.",
    "会社ロゴを削除しました。",
  ],
  [
    "Business logo updated.",
    "Logo de la empresa actualizado.",
    "Logo da empresa atualizado.",
    "会社ロゴを更新しました。",
  ],
  [
    "Cancel and notify",
    "Cancelar y notificar",
    "Cancelar e notificar",
    "キャンセルして通知",
  ],
  ["Cancelling…", "Cancelando…", "Cancelando…", "キャンセル中…"],
  [
    "Choose a JPG, PNG, or WebP image.",
    "Elige una imagen JPG, PNG o WebP.",
    "Escolha uma imagem JPG, PNG ou WebP.",
    "JPG、PNG、またはWebP画像を選択してください。",
  ],
  [
    "Choose a plan to continue",
    "Elige un plan para continuar",
    "Escolha um plano para continuar",
    "続行するプランを選択",
  ],
  ["Choose logo", "Elegir logo", "Escolher logo", "ロゴを選択"],
  ["Choose photo", "Elegir foto", "Escolher foto", "写真を選択"],
  [
    "Choose the client, service, date, and time.",
    "Elige el cliente, servicio, fecha y hora.",
    "Escolha o cliente, o serviço, a data e o horário.",
    "顧客、サービス、日付、時刻を選択してください。",
  ],
  ["cleaning", "limpieza", "limpeza", "清掃"],
  [
    "Cleaning confirmed.",
    "Limpieza confirmada.",
    "Limpeza confirmada.",
    "清掃を確定しました。",
  ],
  [
    "Cleaning created. Approve it when you are ready to notify the client.",
    "Limpieza creada. Apruébala cuando estés listo para notificar al cliente.",
    "Limpeza criada. Aprove quando estiver pronto para notificar o cliente.",
    "清掃を作成しました。顧客に通知する準備ができたら承認してください。",
  ],
  [
    "Cleaning services",
    "Servicios de limpieza",
    "Serviços de limpeza",
    "清掃サービス",
  ],
  [
    "Cleaning updated.",
    "Limpieza actualizada.",
    "Limpeza atualizada.",
    "清掃を更新しました。",
  ],
  [
    "Cleaning updated. Company approval is required.",
    "Limpieza actualizada. Se requiere la aprobación de la empresa.",
    "Limpeza atualizada. É necessária a aprovação da empresa.",
    "清掃を更新しました。会社の承認が必要です。",
  ],
  ["client", "cliente", "cliente", "顧客"],
  ["Client account", "Cuenta de cliente", "Conta de cliente", "顧客アカウント"],
  [
    "Client account connected",
    "Cuenta del cliente conectada",
    "Conta do cliente conectada",
    "顧客アカウント連携済み",
  ],
  [
    "Client added.",
    "Cliente agregado.",
    "Cliente adicionado.",
    "顧客を追加しました。",
  ],
  [
    "Client archived. {count} active cleaning was cancelled.",
    "Cliente archivado. Se canceló {count} limpieza activa.",
    "Cliente arquivado. {count} limpeza ativa foi cancelada.",
    "顧客をアーカイブし、進行中の清掃{count}件をキャンセルしました。",
  ],
  [
    "Client archived. {count} active cleanings were cancelled.",
    "Cliente archivado. Se cancelaron {count} limpiezas activas.",
    "Cliente arquivado. {count} limpezas ativas foram canceladas.",
    "顧客をアーカイブし、進行中の清掃{count}件をキャンセルしました。",
  ],
  [
    "Client archived. Their history is preserved.",
    "Cliente archivado. Su historial se conservó.",
    "Cliente arquivado. O histórico foi preservado.",
    "顧客をアーカイブしました。履歴は保持されています。",
  ],
  [
    "Client updated.",
    "Cliente actualizado.",
    "Cliente atualizado.",
    "顧客を更新しました。",
  ],
  ["Clients", "Clientes", "Clientes", "顧客"],
  ["Close", "Cerrar", "Fechar", "閉じる"],
  [
    "Close media viewer",
    "Cerrar visor de archivos",
    "Fechar visualizador de mídia",
    "メディアビューアを閉じる",
  ],
  [
    "Close navigation",
    "Cerrar navegación",
    "Fechar navegação",
    "ナビゲーションを閉じる",
  ],
  [
    "Close notifications",
    "Cerrar notificaciones",
    "Fechar notificações",
    "通知を閉じる",
  ],
  [
    "Company account",
    "Cuenta de empresa",
    "Conta empresarial",
    "会社アカウント",
  ],
  [
    "Company settings updated.",
    "Configuración de la empresa actualizada.",
    "Configurações da empresa atualizadas.",
    "会社設定を更新しました。",
  ],
  [
    "Complete the required company fields.",
    "Completa los campos obligatorios de la empresa.",
    "Preencha os campos obrigatórios da empresa.",
    "会社の必須項目を入力してください。",
  ],
  ["Confirm", "Confirmar", "Confirmar", "確定"],
  [
    "Confirmation sent to the client.",
    "Solicitud de confirmación enviada al cliente.",
    "Pedido de confirmação enviado ao cliente.",
    "顧客に確認依頼を送信しました。",
  ],
  [
    "Connect client to unlock chat",
    "Conecta al cliente para habilitar el chat",
    "Conecte o cliente para liberar o chat",
    "顧客を連携してチャットを有効にする",
  ],
  ["Connect company", "Conectar empresa", "Conectar empresa", "会社と連携"],
  [
    "Connect this client",
    "Conectar este cliente",
    "Conectar este cliente",
    "この顧客を連携",
  ],
  [
    "Connected with {business}",
    "Conectado con {business}",
    "Conectado com {business}",
    "{business}と連携済み",
  ],
  [
    "Continue with Apple",
    "Continuar con Apple",
    "Continuar com Apple",
    "Appleで続ける",
  ],
  [
    "Continue with Google",
    "Continuar con Google",
    "Continuar com Google",
    "Googleで続ける",
  ],
  [
    "Continue with Microsoft",
    "Continuar con Microsoft",
    "Continuar com Microsoft",
    "Microsoftで続ける",
  ],
  [
    "Conversation ready",
    "Conversación lista",
    "Conversa pronta",
    "会話を開始できます",
  ],
  [
    "Copy invitation code",
    "Copiar código de invitación",
    "Copiar código de convite",
    "招待コードをコピー",
  ],
  [
    "Could not approve this cleaning.",
    "No se pudo aprobar esta limpieza.",
    "Não foi possível aprovar esta limpeza.",
    "この清掃を承認できませんでした。",
  ],
  [
    "Create a private code. Chat unlocks after the client accepts it in TidyPing.",
    "Crea un código privado. El chat se habilita cuando el cliente lo acepta en TidyPing.",
    "Crie um código privado. O chat é liberado depois que o cliente aceita no TidyPing.",
    "非公開コードを作成してください。顧客がTidyPingで承認するとチャットが利用可能になります。",
  ],
  ["Create cleaning", "Crear limpieza", "Criar limpeza", "清掃を作成"],
  [
    "Create company workspace",
    "Crear espacio de la empresa",
    "Criar workspace da empresa",
    "会社ワークスペースを作成",
  ],
  ["Date", "Fecha", "Data", "日付"],
  ["Deleting…", "Eliminando…", "Excluindo…", "削除中…"],
  [
    "Draft invoice generated.",
    "Borrador de factura generado.",
    "Rascunho da fatura gerado.",
    "請求書の下書きを作成しました。",
  ],
  ["Due {date}", "Vence el {date}", "Vence em {date}", "支払期限：{date}"],
  [
    "Enter a valid email address.",
    "Ingresa un correo electrónico válido.",
    "Digite um e-mail válido.",
    "有効なメールアドレスを入力してください。",
  ],
  [
    "Enter an email or phone number.",
    "Ingresa un correo o un número de teléfono.",
    "Digite um e-mail ou telefone.",
    "メールアドレスまたは電話番号を入力してください。",
  ],
  [
    "Enter the complete invitation code from your cleaning company.",
    "Ingresa el código de invitación completo de tu empresa de limpieza.",
    "Digite o código de convite completo da sua empresa de limpeza.",
    "清掃会社から届いた完全な招待コードを入力してください。",
  ],
  [
    "Entry instructions, priorities, pets, supplies…",
    "Instrucciones de entrada, prioridades, mascotas, suministros…",
    "Instruções de entrada, prioridades, animais, materiais…",
    "入室方法、優先事項、ペット、備品など…",
  ],
  [
    "Every {count} days",
    "Cada {count} días",
    "A cada {count} dias",
    "{count}日ごと",
  ],
  [
    "Every {count} weeks",
    "Cada {count} semanas",
    "A cada {count} semanas",
    "{count}週間ごと",
  ],
  [
    "Every cleaning needs a client and service address. Create one now, then come back to schedule.",
    "Cada limpieza necesita un cliente y una dirección de servicio. Crea uno ahora y después vuelve a la agenda.",
    "Toda limpeza precisa de um cliente e um endereço de serviço. Crie um agora e depois volte para a agenda.",
    "すべての清掃には顧客とサービス先住所が必要です。今すぐ顧客を作成してから、スケジュールに戻ってください。",
  ],
  ["Every week", "Cada semana", "Toda semana", "毎週"],
  ["Finance", "Finanzas", "Financeiro", "財務"],
  [
    "For example: family emergency",
    "Por ejemplo: emergencia familiar",
    "Por exemplo: emergência familiar",
    "例：家族の緊急事態",
  ],
  [
    "For security, delete an Apple-linked account from TidyPing on your iPhone.",
    "Por seguridad, elimina una cuenta vinculada con Apple desde TidyPing en tu iPhone.",
    "Por segurança, exclua uma conta vinculada à Apple pelo TidyPing no seu iPhone.",
    "セキュリティ保護のため、Apple連携アカウントはiPhone版TidyPingから削除してください。",
  ],
  ["Generate draft", "Generar borrador", "Gerar rascunho", "下書きを作成"],
  ["Generating…", "Generando…", "Gerando…", "作成中…"],
  ["Get code", "Obtener código", "Obter código", "コードを取得"],
  [
    "Get invite code",
    "Obtener código de invitación",
    "Obter código de convite",
    "招待コードを取得",
  ],
  ["Good afternoon", "Buenas tardes", "Boa tarde", "こんにちは"],
  ["Good evening", "Buenas noches", "Boa noite", "こんばんは"],
  ["Good morning", "Buenos días", "Bom dia", "おはようございます"],
  ["Granting…", "Concediendo…", "Concedendo…", "付与中…"],
  [
    "Here’s what needs attention at {business}.",
    "Esto es lo que necesita atención en {business}.",
    "Veja o que precisa de atenção na {business}.",
    "{business}で対応が必要な項目です。",
  ],
  [
    "If no other active owner exists, the entire company workspace, schedules, messages, invoices, and uploaded media will also be deleted.",
    "Si no existe otro propietario activo, también se eliminarán todo el espacio de la empresa, las agendas, los mensajes, las facturas y los archivos subidos.",
    "Se não houver outro proprietário ativo, todo o workspace da empresa, agendas, mensagens, faturas e mídias enviadas também serão excluídos.",
    "ほかに有効なオーナーがいない場合、会社のワークスペース、スケジュール、メッセージ、請求書、アップロード済みメディアもすべて削除されます。",
  ],
  [
    "Invitation code copied.",
    "Código de invitación copiado.",
    "Código de convite copiado.",
    "招待コードをコピーしました。",
  ],
  [
    "Invitation copied and ready to share.",
    "Invitación copiada y lista para compartir.",
    "Convite copiado e pronto para compartilhar.",
    "招待をコピーしました。共有できます。",
  ],
  [
    "Invitation link copied.",
    "Enlace de invitación copiado.",
    "Link de convite copiado.",
    "招待リンクをコピーしました。",
  ],
  [
    "Invoice {number}",
    "Factura {number}",
    "Fatura {number}",
    "請求書 {number}",
  ],
  [
    "Invoice {number} is ready in TidyPing.",
    "La factura {number} está disponible en TidyPing.",
    "A fatura {number} está disponível no TidyPing.",
    "請求書{number}をTidyPingで確認できます。",
  ],
  [
    "Invoice marked {status}.",
    "Factura marcada como {status}.",
    "Fatura marcada como {status}.",
    "請求書を「{status}」に変更しました。",
  ],
  [
    "Invoice sent inside TidyPing.",
    "Factura enviada dentro de TidyPing.",
    "Fatura enviada dentro do TidyPing.",
    "請求書をTidyPing内で送信しました。",
  ],
  ["Invoices", "Facturas", "Faturas", "請求書"],
  ["Issued {date}", "Emitida el {date}", "Emitida em {date}", "発行日：{date}"],
  [
    "Join {business} on TidyPing. Or enter code {code}.",
    "Únete a {business} en TidyPing. También puedes ingresar el código {code}.",
    "Entre na {business} pelo TidyPing. Ou digite o código {code}.",
    "TidyPingで{business}に参加してください。またはコード{code}を入力してください。",
  ],
  ["Jump to date", "Ir a una fecha", "Ir para uma data", "日付へ移動"],
  [
    "Last seen {time}",
    "Última vez {time}",
    "Visto por último {time}",
    "最終オンライン：{time}",
  ],
  [
    "Manual access granted and audited.",
    "Acceso manual concedido y auditado.",
    "Acesso manual concedido e auditado.",
    "手動アクセスを付与し、監査記録を保存しました。",
  ],
  [
    "Message {name}",
    "Mensaje para {name}",
    "Mensagem para {name}",
    "{name}にメッセージ",
  ],
  ["Messages", "Mensajes", "Mensagens", "メッセージ"],
  [
    "Microsoft sign-in could not start.",
    "No se pudo iniciar sesión con Microsoft.",
    "Não foi possível iniciar o login com a Microsoft.",
    "Microsoftサインインを開始できませんでした。",
  ],
  [
    "Mobile navigation",
    "Navegación móvil",
    "Navegação móvel",
    "モバイルナビゲーション",
  ],
  [
    "New invoice available",
    "Nueva factura disponible",
    "Nova fatura disponível",
    "新しい請求書があります",
  ],
  [
    "New time sent to the client for confirmation.",
    "Nuevo horario enviado al cliente para confirmación.",
    "Novo horário enviado ao cliente para confirmação.",
    "新しい日時を顧客に送信し、確認を依頼しました。",
  ],
  ["Next month", "Mes siguiente", "Próximo mês", "次の月"],
  [
    "No active cleanings will be affected.",
    "Ninguna limpieza activa se verá afectada.",
    "Nenhuma limpeza ativa será afetada.",
    "進行中の清掃には影響しません。",
  ],
  [
    "No invitation code was returned.",
    "No se recibió ningún código de invitación.",
    "Nenhum código de convite foi retornado.",
    "招待コードを取得できませんでした。",
  ],
  ["Not specified", "No especificado", "Não informado", "未指定"],
  [
    "Nothing needs approval right now.",
    "Nada necesita aprobación en este momento.",
    "Nada precisa de aprovação agora.",
    "現在、承認が必要な項目はありません。",
  ],
  ["Offline", "Desconectado", "Offline", "オフライン"],
  [
    "One schedule update needs you",
    "Un cambio de agenda necesita tu respuesta",
    "Uma atualização da agenda precisa de você",
    "スケジュール更新1件に対応が必要です",
  ],
  ["Open chat", "Abrir chat", "Abrir chat", "チャットを開く"],
  [
    "Open image {file}",
    "Abrir imagen {file}",
    "Abrir imagem {file}",
    "画像{file}を開く",
  ],
  [
    "Open navigation",
    "Abrir navegación",
    "Abrir navegação",
    "ナビゲーションを開く",
  ],
  [
    "Open video {file}",
    "Abrir video {file}",
    "Abrir vídeo {file}",
    "動画{file}を開く",
  ],
  [
    "Opening Apple…",
    "Abriendo Apple…",
    "Abrindo Apple…",
    "Appleを開いています…",
  ],
  [
    "Opening Google…",
    "Abriendo Google…",
    "Abrindo Google…",
    "Googleを開いています…",
  ],
  [
    "Opening Microsoft…",
    "Abriendo Microsoft…",
    "Abrindo Microsoft…",
    "Microsoftを開いています…",
  ],
  ["Paid", "Pagada", "Paga", "支払済み"],
  ["Paid · {date}", "Pagada · {date}", "Pago · {date}", "支払済み・{date}"],
  ["Paid {date}", "Pagada el {date}", "Pago em {date}", "{date}に支払済み"],
  [
    "Payment is handled directly with the cleaning company. No payment was collected by TidyPing.",
    "El pago se gestiona directamente con la empresa de limpieza. TidyPing no cobró ningún pago.",
    "O pagamento é feito diretamente com a empresa de limpeza. O TidyPing não recebeu nenhum pagamento.",
    "支払いは清掃会社と直接行われます。TidyPingは代金を受領していません。",
  ],
  [
    "Payment recorded in collected revenue.",
    "Pago registrado en los ingresos cobrados.",
    "Pagamento registrado no faturamento recebido.",
    "支払いを入金済み売上に記録しました。",
  ],
  [
    "Payment status could not be updated.",
    "No se pudo actualizar el estado del pago.",
    "Não foi possível atualizar o status do pagamento.",
    "支払い状況を更新できませんでした。",
  ],
  [
    "Permanently delete",
    "Eliminar permanentemente",
    "Excluir permanentemente",
    "完全に削除",
  ],
  ["Photo or video", "Foto o video", "Foto ou vídeo", "写真または動画"],
  ["Previous month", "Mes anterior", "Mês anterior", "前の月"],
  [
    "Price & assignment",
    "Precio y asignación",
    "Preço e atribuição",
    "料金と担当",
  ],
  [
    "Primary navigation",
    "Navegación principal",
    "Navegação principal",
    "メインナビゲーション",
  ],
  [
    "Private invitation created.",
    "Invitación privada creada.",
    "Convite privado criado.",
    "非公開招待を作成しました。",
  ],
  [
    "Profile photo removed.",
    "Foto de perfil eliminada.",
    "Foto do perfil removida.",
    "プロフィール写真を削除しました。",
  ],
  [
    "Profile photo updated.",
    "Foto de perfil actualizada.",
    "Foto do perfil atualizada.",
    "プロフィール写真を更新しました。",
  ],
  [
    "Recurring plan renewed through {month}.",
    "Plan recurrente renovado hasta {month}.",
    "Plano recorrente renovado até {month}.",
    "定期プランを{month}まで更新しました。",
  ],
  [
    "Registration could not be completed.",
    "No se pudo completar el registro.",
    "Não foi possível concluir o cadastro.",
    "登録を完了できませんでした。",
  ],
  ["Remove {file}", "Eliminar {file}", "Remover {file}", "{file}を削除"],
  [
    "Renew {client} for {month}",
    "Renovar a {client} para {month}",
    "Renovar {client} para {month}",
    "{client}の{month}分を更新",
  ],
  ["Renew one month", "Renovar un mes", "Renovar um mês", "1か月更新"],
  ["Renewing…", "Renovando…", "Renovando…", "更新中…"],
  ["Replace code", "Reemplazar código", "Substituir código", "コードを再発行"],
  ["Replace logo", "Reemplazar logo", "Substituir logo", "ロゴを変更"],
  ["Replace photo", "Reemplazar foto", "Substituir foto", "写真を変更"],
  ["Required first", "Se requiere primero", "Obrigatório primeiro", "先に必要"],
  [
    "Reschedule or edit",
    "Reprogramar o editar",
    "Reagendar ou editar",
    "日時変更または編集",
  ],
  ["Restore", "Restaurar", "Restaurar", "復元"],
  ["Restoring…", "Restaurando…", "Restaurando…", "復元中…"],
  [
    "Review before clients are notified",
    "Revisar antes de notificar a los clientes",
    "Revise antes de notificar os clientes",
    "顧客への通知前に確認",
  ],
  [
    "Save & create invite",
    "Guardar y crear invitación",
    "Salvar e criar convite",
    "保存して招待を作成",
  ],
  ["Save changes", "Guardar cambios", "Salvar alterações", "変更を保存"],
  ["Save company", "Guardar empresa", "Salvar empresa", "会社情報を保存"],
  ["Save profile", "Guardar perfil", "Salvar perfil", "プロフィールを保存"],
  ["Saving…", "Guardando…", "Salvando…", "保存中…"],
  ["Schedule", "Agenda", "Agenda", "スケジュール"],
  [
    "Schedule is clear",
    "La agenda está libre",
    "A agenda está livre",
    "本日の予定はありません",
  ],
  [
    "Schedule, chat, notifications, and invoices are shared.",
    "La agenda, el chat, las notificaciones y las facturas están compartidos.",
    "Agenda, chat, notificações e faturas estão compartilhados.",
    "スケジュール、チャット、通知、請求書が共有されています。",
  ],
  ["Search clients", "Buscar clientes", "Buscar clientes", "顧客を検索"],
  [
    "Search company or owner",
    "Buscar empresa o propietario",
    "Buscar empresa ou proprietário",
    "会社またはオーナーを検索",
  ],
  [
    "Search name, address, email, or phone",
    "Buscar nombre, dirección, correo o teléfono",
    "Buscar nome, endereço, e-mail ou telefone",
    "氏名、住所、メール、電話番号で検索",
  ],
  [
    "Send change request",
    "Enviar solicitud de cambio",
    "Enviar pedido de alteração",
    "変更依頼を送信",
  ],
  ["Send message", "Enviar mensaje", "Enviar mensagem", "メッセージを送信"],
  [
    "Send support request",
    "Enviar solicitud de soporte",
    "Enviar solicitação de suporte",
    "サポート依頼を送信",
  ],
  ["Sending…", "Enviando…", "Enviando…", "送信中…"],
  [
    "Set the expected charge and team.",
    "Define el importe previsto y el equipo.",
    "Defina o valor previsto e a equipe.",
    "予定料金と担当チームを設定します。",
  ],
  ["Settings", "Configuración", "Configurações", "設定"],
  [
    "Sign in could not start.",
    "No se pudo iniciar el inicio de sesión.",
    "Não foi possível iniciar o login.",
    "サインインを開始できませんでした。",
  ],
  [
    "Sign in to accept your private cleaning company invitation.",
    "Inicia sesión para aceptar la invitación privada de tu empresa de limpieza.",
    "Entre para aceitar o convite privado da sua empresa de limpeza.",
    "サインインして清掃会社からの非公開招待を承認してください。",
  ],
  [
    "Sign in with the exact work email named in your private employee invitation.",
    "Inicia sesión con el correo laboral exacto indicado en tu invitación privada de empleado.",
    "Entre exatamente com o e-mail profissional indicado no convite privado de funcionário.",
    "従業員向け非公開招待に指定された勤務先メールアドレスでサインインしてください。",
  ],
  [
    "Step {current} of {total}",
    "Paso {current} de {total}",
    "Etapa {current} de {total}",
    "ステップ{current}/{total}",
  ],
  [
    "Support request saved · {ticket}",
    "Solicitud de soporte guardada · {ticket}",
    "Solicitação de suporte salva · {ticket}",
    "サポート依頼を保存しました・{ticket}",
  ],
  [
    "Support ticket updated.",
    "Ticket de soporte actualizado.",
    "Chamado de suporte atualizado.",
    "サポートチケットを更新しました。",
  ],
  [
    "Tap to review today",
    "Toca para revisar el día",
    "Toque para revisar o dia",
    "タップして本日分を確認",
  ],
  [
    "Team assignment",
    "Asignación del equipo",
    "Atribuição da equipe",
    "チーム担当",
  ],
  [
    "Team member added.",
    "Miembro del equipo agregado.",
    "Membro da equipe adicionado.",
    "チームメンバーを追加しました。",
  ],
  [
    "Team member updated.",
    "Miembro del equipo actualizado.",
    "Membro da equipe atualizado.",
    "チームメンバーを更新しました。",
  ],
  [
    "Temporary manual access for {business}.",
    "Acceso manual temporal para {business}.",
    "Acesso manual temporário para {business}.",
    "{business}への一時的な手動アクセスです。",
  ],
  [
    "That image could not be opened.",
    "No se pudo abrir esa imagen.",
    "Não foi possível abrir essa imagem.",
    "画像を開けませんでした。",
  ],
  [
    "That time conflicts with another cleaning or travel buffer.",
    "Ese horario entra en conflicto con otra limpieza o con el margen de traslado.",
    "Esse horário entra em conflito com outra limpeza ou com o intervalo de deslocamento.",
    "その時間は別の清掃または移動時間と重なっています。",
  ],
  [
    "The active code ends in {hint}. Full codes are shown only when generated.",
    "El código activo termina en {hint}. Los códigos completos solo se muestran al generarlos.",
    "O código ativo termina em {hint}. O código completo só aparece quando é gerado.",
    "有効なコードの末尾は{hint}です。完全なコードは発行時にのみ表示されます。",
  ],
  [
    "The cleaning could not be saved.",
    "No se pudo guardar la limpieza.",
    "Não foi possível salvar a limpeza.",
    "清掃を保存できませんでした。",
  ],
  [
    "The client could not be saved.",
    "No se pudo guardar el cliente.",
    "Não foi possível salvar o cliente.",
    "顧客を保存できませんでした。",
  ],
  [
    "The client is notified only after company approval.",
    "El cliente recibe la notificación solo después de la aprobación de la empresa.",
    "O cliente só é notificado depois da aprovação da empresa.",
    "顧客への通知は会社の承認後にのみ送信されます。",
  ],
  [
    "The client must accept the private invitation before chat is available.",
    "El cliente debe aceptar la invitación privada antes de poder usar el chat.",
    "O cliente precisa aceitar o convite privado antes de usar o chat.",
    "チャットを利用するには、顧客が非公開招待を承認する必要があります。",
  ],
  [
    "The company approves the new time by sending it; the client is notified to confirm.",
    "La empresa aprueba el nuevo horario al enviarlo; el cliente recibe una notificación para confirmarlo.",
    "A empresa aprova o novo horário ao enviá-lo; o cliente é notificado para confirmar.",
    "会社が新しい日時を送信すると承認となり、顧客に確認通知が届きます。",
  ],
  [
    "The company plan needs attention",
    "El plan de la empresa necesita atención",
    "O plano da empresa precisa de atenção",
    "会社のプランに対応が必要です",
  ],
  [
    "The image could not be encoded.",
    "No se pudo procesar la imagen.",
    "Não foi possível processar a imagem.",
    "画像をエンコードできませんでした。",
  ],
  [
    "The invitation could not be created. Please try again.",
    "No se pudo crear la invitación. Inténtalo de nuevo.",
    "Não foi possível criar o convite. Tente novamente.",
    "招待を作成できませんでした。もう一度お試しください。",
  ],
  [
    "The invoice could not be generated.",
    "No se pudo generar la factura.",
    "Não foi possível gerar a fatura.",
    "請求書を作成できませんでした。",
  ],
  [
    "The invoice could not be sent.",
    "No se pudo enviar la factura.",
    "Não foi possível enviar a fatura.",
    "請求書を送信できませんでした。",
  ],
  [
    "The message could not be sent.",
    "No se pudo enviar el mensaje.",
    "Não foi possível enviar a mensagem.",
    "メッセージを送信できませんでした。",
  ],
  [
    "The new client could not be reopened.",
    "No se pudo volver a abrir el nuevo cliente.",
    "Não foi possível reabrir o novo cliente.",
    "新しい顧客を開き直せませんでした。",
  ],
  [
    "The recurring plan could not be renewed.",
    "No se pudo renovar el plan recurrente.",
    "Não foi possível renovar o plano recorrente.",
    "定期プランを更新できませんでした。",
  ],
  [
    "The schedule could not be updated.",
    "No se pudo actualizar la agenda.",
    "Não foi possível atualizar a agenda.",
    "スケジュールを更新できませんでした。",
  ],
  [
    "This browser could not prepare the image.",
    "Este navegador no pudo preparar la imagen.",
    "Este navegador não conseguiu preparar a imagem.",
    "このブラウザでは画像を処理できませんでした。",
  ],
  ["This identity", "Esta identidad", "Esta identidade", "このID"],
  [
    "TidyPing invitation for {name}",
    "Invitación de TidyPing para {name}",
    "Convite do TidyPing para {name}",
    "{name}へのTidyPing招待",
  ],
  [
    "TidyPing user",
    "Usuario de TidyPing",
    "Usuário do TidyPing",
    "TidyPingユーザー",
  ],
  [
    "Trial access through {date}.",
    "Acceso de prueba hasta el {date}.",
    "Acesso de teste até {date}.",
    "{date}までトライアルを利用できます。",
  ],
  [
    "Unable to remove this image.",
    "No se pudo eliminar esta imagen.",
    "Não foi possível remover esta imagem.",
    "この画像を削除できませんでした。",
  ],
  [
    "Unable to update this image.",
    "No se pudo actualizar esta imagen.",
    "Não foi possível atualizar esta imagem.",
    "この画像を更新できませんでした。",
  ],
  ["Unassigned", "Sin asignar", "Não atribuído", "未割り当て"],
  [
    "Uploading {current} of {total}…",
    "Subiendo {current} de {total}…",
    "Enviando {current} de {total}…",
    "{total}件中{current}件をアップロード中…",
  ],
  [
    "Use the same account on iPhone and web. If it’s new, we’ll guide you through setup.",
    "Usa la misma cuenta en iPhone y web. Si es nueva, te guiaremos durante la configuración.",
    "Use a mesma conta no iPhone e na web. Se for nova, vamos orientar você durante a configuração.",
    "iPhoneとWebで同じアカウントを使用してください。新規の場合は設定をご案内します。",
  ],
  [
    "Waiting for client acceptance",
    "Esperando la aceptación del cliente",
    "Aguardando o aceite do cliente",
    "顧客の承認待ち",
  ],
  [
    "Waiting for client to accept invite",
    "Esperando que el cliente acepte la invitación",
    "Aguardando o cliente aceitar o convite",
    "顧客の招待承認待ち",
  ],
  ["Working…", "Procesando…", "Processando…", "処理中…"],
  [
    "You've been invited to join {business} on TidyPing. Sign in with {email}: {url}",
    "Te invitaron a unirte a {business} en TidyPing. Inicia sesión con {email}: {url}",
    "Você foi convidado para entrar na {business} pelo TidyPing. Entre com {email}: {url}",
    "TidyPingで{business}に招待されました。{email}でサインインしてください：{url}",
  ],
  [
    "your cleaning company",
    "tu empresa de limpieza",
    "sua empresa de limpeza",
    "清掃会社",
  ],
  [
    "Your cleaning operation at a glance.",
    "Tu operación de limpieza de un vistazo.",
    "Sua operação de limpeza em um só lugar.",
    "清掃業務の概要です。",
  ],
  [
    "Your complimentary access has ended. Open TidyPing on the owner’s iPhone to choose a plan securely through the App Store, or restore an existing purchase.",
    "Tu acceso gratuito terminó. Abre TidyPing en el iPhone del propietario para elegir un plan de forma segura en App Store o restaurar una compra existente.",
    "Seu acesso gratuito terminou. Abra o TidyPing no iPhone do proprietário para escolher um plano com segurança pela App Store ou restaurar uma compra existente.",
    "無料アクセス期間が終了しました。オーナーのiPhoneでTidyPingを開き、App Storeから安全にプランを選択するか、既存の購入を復元してください。",
  ],
  [
    "Your sign-in, workspace connection, notification tokens, and private account data will be removed.",
    "Se eliminarán tu inicio de sesión, conexión al espacio de trabajo, tokens de notificación y datos privados de la cuenta.",
    "Seu login, conexão com o workspace, tokens de notificação e dados privados da conta serão removidos.",
    "サインイン情報、ワークスペース連携、通知トークン、非公開アカウントデータが削除されます。",
  ],
  [
    "Your TidyPing account was permanently deleted.",
    "Tu cuenta de TidyPing se eliminó permanentemente.",
    "Sua conta do TidyPing foi excluída permanentemente.",
    "TidyPingアカウントを完全に削除しました。",
  ],
  [
    "Your TidyPing workspace is ready.",
    "Tu espacio de TidyPing está listo.",
    "Seu workspace do TidyPing está pronto.",
    "TidyPingワークスペースの準備ができました。",
  ],
  [
    "Your workspace has active access.",
    "Tu espacio de trabajo tiene acceso activo.",
    "Seu workspace está com acesso ativo.",
    "ワークスペースは利用可能です。",
  ],
  [
    "{count} new openings",
    "{count} nuevos horarios disponibles",
    "{count} novos horários disponíveis",
    "新しい空き時間が{count}件あります",
  ],
  [
    "{count} openings suggested",
    "{count} horarios sugeridos",
    "{count} horários sugeridos",
    "空き時間を{count}件提案しました",
  ],
  [
    "{service} is finished. Open TidyPing to view the details.",
    "{service} ha terminado. Abre TidyPing para ver los detalles.",
    "{service} foi concluído. Abra o TidyPing para ver os detalhes.",
    "{service}が完了しました。詳細はTidyPingで確認できます。",
  ],
  [
    "{service} was marked paid by the cleaning company.",
    "La empresa de limpieza marcó {service} como pagado.",
    "A empresa de limpeza marcou {service} como pago.",
    "清掃会社が{service}を支払済みにしました。",
  ],
  [
    "A cleaning was proposed for {slot}. Business approval is required before the client is notified.",
    "Se propuso una limpieza para {slot}. La empresa debe aprobarla antes de notificar al cliente.",
    "Uma limpeza foi proposta para {slot}. A empresa precisa aprovar antes que o cliente seja notificado.",
    "{slot}の清掃が提案されました。顧客への通知前に会社の承認が必要です。",
  ],
  [
    "A confirmed cleaning cannot be moved to another client. Cancel it and create a new cleaning instead.",
    "Una limpieza confirmada no puede asignarse a otro cliente. Cancélala y crea una nueva.",
    "Uma limpeza confirmada não pode ser movida para outro cliente. Cancele-a e crie uma nova limpeza.",
    "確定済みの清掃を別の顧客に変更することはできません。キャンセルして新しい清掃を作成してください。",
  ],
  [
    "A new time cannot be requested for this cleaning right now.",
    "No se puede solicitar otro horario para esta limpieza en este momento.",
    "Não é possível solicitar outro horário para esta limpeza agora.",
    "現在、この清掃の新しい日時はリクエストできません。",
  ],
  [
    "An upcoming recurring cleaning is ready for business approval.",
    "Una próxima limpieza recurrente está lista para la aprobación de la empresa.",
    "Uma próxima limpeza recorrente está pronta para aprovação da empresa.",
    "次回の定期清掃を会社が承認できる状態になりました。",
  ],
  [
    "Cleaning cancelled",
    "Limpieza cancelada",
    "Limpeza cancelada",
    "清掃がキャンセルされました",
  ],
  [
    "Cleaning completed",
    "Limpieza completada",
    "Limpeza concluída",
    "清掃が完了しました",
  ],
  [
    "Cleaning time changed",
    "Cambió el horario de la limpieza",
    "Horário da limpeza alterado",
    "清掃日時が変更されました",
  ],
  [
    "Client cancelled cleaning",
    "El cliente canceló la limpieza",
    "O cliente cancelou a limpeza",
    "顧客が清掃をキャンセルしました",
  ],
  [
    "Client confirmed",
    "El cliente confirmó",
    "Cliente confirmou",
    "顧客が確認しました",
  ],
  [
    "Client requested another time",
    "El cliente solicitó otro horario",
    "O cliente solicitou outro horário",
    "顧客が別の日時をリクエストしました",
  ],
  [
    "Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY",
    "Falta VITE_SUPABASE_URL o VITE_SUPABASE_ANON_KEY",
    "VITE_SUPABASE_URL ou VITE_SUPABASE_ANON_KEY não foi configurada",
    "VITE_SUPABASE_URLまたはVITE_SUPABASE_ANON_KEYがありません",
  ],
  [
    "New cleaning needs approval",
    "Una nueva limpieza necesita aprobación",
    "Nova limpeza precisa de aprovação",
    "新しい清掃の承認が必要です",
  ],
  [
    "New message from {name}",
    "Nuevo mensaje de {name}",
    "Nova mensagem de {name}",
    "{name}さんから新しいメッセージがあります",
  ],
  [
    "New time selected",
    "Nuevo horario seleccionado",
    "Novo horário selecionado",
    "新しい日時が選択されました",
  ],
  [
    "No open times were found. Ask the company in chat.",
    "No se encontraron horarios disponibles. Consulta a la empresa por el chat.",
    "Nenhum horário disponível foi encontrado. Fale com a empresa pelo chat.",
    "空き時間が見つかりませんでした。チャットで会社にお問い合わせください。",
  ],
  [
    "Only a confirmed cleaning can be cancelled by the client.",
    "El cliente solo puede cancelar una limpieza confirmada.",
    "O cliente só pode cancelar uma limpeza confirmada.",
    "顧客がキャンセルできるのは確定済みの清掃のみです。",
  ],
  [
    "Please choose another time",
    "Elige otro horario",
    "Escolha outro horário",
    "別の日時を選択してください",
  ],
  [
    "Please confirm {slot}.",
    "Confirma {slot}.",
    "Confirme {slot}.",
    "{slot}を確認してください。",
  ],
  [
    "Please confirm your cleaning",
    "Confirma tu limpieza",
    "Confirme sua limpeza",
    "清掃日時を確認してください",
  ],
  [
    "Recurring cleaning needs approval",
    "La limpieza recurrente necesita aprobación",
    "A limpeza recorrente precisa de aprovação",
    "定期清掃の承認が必要です",
  ],
  [
    "Schedule confirmed",
    "Agenda confirmada",
    "Agenda confirmada",
    "スケジュールが確定しました",
  ],
  [
    "Sent a photo or video.",
    "Envió una foto o un video.",
    "Enviou uma foto ou um vídeo.",
    "写真または動画を送信しました。",
  ],
  [
    "Sent {count} photos or videos.",
    "Envió {count} fotos o videos.",
    "Enviou {count} fotos ou vídeos.",
    "写真または動画を{count}件送信しました。",
  ],
  [
    "That action is no longer available.",
    "Esa acción ya no está disponible.",
    "Essa ação não está mais disponível.",
    "その操作は利用できなくなりました。",
  ],
  [
    "That approval is no longer available.",
    "Esa aprobación ya no está disponible.",
    "Essa aprovação não está mais disponível.",
    "その承認は利用できなくなりました。",
  ],
  [
    "That time conflicts with another cleaning or the travel buffer.",
    "Ese horario entra en conflicto con otra limpieza o con el margen de traslado.",
    "Esse horário entra em conflito com outra limpeza ou com o intervalo de deslocamento.",
    "その時間は別の清掃または移動時間と重なっています。",
  ],
  [
    "That time is no longer available.",
    "Ese horario ya no está disponible.",
    "Esse horário não está mais disponível.",
    "その日時は利用できなくなりました。",
  ],
  [
    "The business approved the proposed time. Client confirmation is needed.",
    "La empresa aprobó el horario propuesto. Falta la confirmación del cliente.",
    "A empresa aprovou o horário proposto. Falta a confirmação do cliente.",
    "会社が提案日時を承認しました。顧客の確認が必要です。",
  ],
  [
    "The business cancelled this cleaning. Reason: {reason}",
    "La empresa canceló esta limpieza. Motivo: {reason}",
    "A empresa cancelou esta limpeza. Motivo: {reason}",
    "会社がこの清掃をキャンセルしました。理由：{reason}",
  ],
  [
    "The business cancelled this cleaning.",
    "La empresa canceló esta limpieza.",
    "A empresa cancelou esta limpeza.",
    "会社がこの清掃をキャンセルしました。",
  ],
  [
    "The business confirmed the selected time. The service is now scheduled.",
    "La empresa confirmó el horario seleccionado. El servicio ya está agendado.",
    "A empresa confirmou o horário selecionado. O serviço está agendado.",
    "会社が選択日時を確認しました。サービスが確定しました。",
  ],
  [
    "The business must approve this time first.",
    "La empresa debe aprobar este horario primero.",
    "A empresa precisa aprovar este horário primeiro.",
    "最初に会社がこの日時を承認する必要があります。",
  ],
  [
    "The business requested a new time: {slot}. The client must confirm the change.",
    "La empresa solicitó un nuevo horario: {slot}. El cliente debe confirmar el cambio.",
    "A empresa solicitou um novo horário: {slot}. O cliente precisa confirmar a alteração.",
    "会社が新しい日時（{slot}）をリクエストしました。顧客の確認が必要です。",
  ],
  [
    "The cleaning has started.",
    "La limpieza ha comenzado.",
    "A limpeza começou.",
    "清掃が開始されました。",
  ],
  [
    "The cleaning was completed. Payment is still pending.",
    "La limpieza se completó. El pago sigue pendiente.",
    "A limpeza foi concluída. O pagamento continua pendente.",
    "清掃が完了しました。支払いは保留中です。",
  ],
  [
    "The cleaning was completed. Payment was recorded as paid.",
    "La limpieza se completó. El pago se registró como pagado.",
    "A limpeza foi concluída. O pagamento foi registrado como pago.",
    "清掃が完了し、支払いを支払済みとして記録しました。",
  ],
  [
    "The cleaning time changed to {slot}. Both confirmations were reset.",
    "El horario de la limpieza cambió a {slot}. Se restablecieron ambas confirmaciones.",
    "O horário da limpeza mudou para {slot}. As duas confirmações foram redefinidas.",
    "清掃日時が{slot}に変更され、双方の確認がリセットされました。",
  ],
  [
    "The client cancelled this cleaning. Reason: {reason}",
    "El cliente canceló esta limpieza. Motivo: {reason}",
    "O cliente cancelou esta limpeza. Motivo: {reason}",
    "顧客がこの清掃をキャンセルしました。理由：{reason}",
  ],
  [
    "The client cancelled this cleaning.",
    "El cliente canceló esta limpieza.",
    "O cliente cancelou esta limpeza.",
    "顧客がこの清掃をキャンセルしました。",
  ],
  [
    "The client confirmed the time. The service is now scheduled.",
    "El cliente confirmó el horario. El servicio ya está agendado.",
    "O cliente confirmou o horário. O serviço está agendado.",
    "顧客が日時を確認しました。サービスが確定しました。",
  ],
  [
    "The client requested another time. TidyPing suggested available openings.",
    "El cliente solicitó otro horario. TidyPing sugirió opciones disponibles.",
    "O cliente solicitou outro horário. O TidyPing sugeriu opções disponíveis.",
    "顧客が別の日時をリクエストし、TidyPingが空き時間を提案しました。",
  ],
  [
    "The client selected {slot}. Business approval is needed.",
    "El cliente seleccionó {slot}. Se necesita la aprobación de la empresa.",
    "O cliente selecionou {slot}. É necessária a aprovação da empresa.",
    "顧客が{slot}を選択しました。会社の承認が必要です。",
  ],
  [
    "The selected time did not work for the business. Fresh openings were suggested.",
    "El horario seleccionado no funcionó para la empresa. Se sugirieron nuevas opciones.",
    "O horário selecionado não funcionou para a empresa. Novas opções foram sugeridas.",
    "選択日時は会社の都合に合わなかったため、新しい空き時間を提案しました。",
  ],
  [
    "The temporary hold expired. Ask the client to choose a new time.",
    "La reserva temporal venció. Pide al cliente que elija otro horario.",
    "A reserva temporária expirou. Peça ao cliente para escolher outro horário.",
    "一時的な仮押さえの期限が切れました。顧客に別の日時を選んでもらってください。",
  ],
  [
    "This cleaning can no longer be cancelled.",
    "Esta limpieza ya no se puede cancelar.",
    "Esta limpeza não pode mais ser cancelada.",
    "この清掃はキャンセルできなくなりました。",
  ],
  [
    "This cleaning changed on another device. Refresh and try again.",
    "Esta limpieza cambió en otro dispositivo. Actualiza e inténtalo de nuevo.",
    "Esta limpeza foi alterada em outro dispositivo. Atualize e tente novamente.",
    "この清掃は別のデバイスで変更されました。更新してもう一度お試しください。",
  ],
  [
    "This recurring plan is no longer available.",
    "Este plan recurrente ya no está disponible.",
    "Este plano recorrente não está mais disponível.",
    "この定期プランは利用できなくなりました。",
  ],
  [
    "Unable to create this cleaning.",
    "No se pudo crear esta limpieza.",
    "Não foi possível criar esta limpeza.",
    "この清掃を作成できませんでした。",
  ],
  [
    "Unable to load this workspace.",
    "No se pudo cargar este espacio de trabajo.",
    "Não foi possível carregar este workspace.",
    "このワークスペースを読み込めませんでした。",
  ],
  [
    "Updated cleaning needs approval",
    "La limpieza actualizada necesita aprobación",
    "A limpeza atualizada precisa de aprovação",
    "更新した清掃の承認が必要です",
  ],
  [
    "Payment recorded",
    "Pago registrado",
    "Pagamento registrado",
    "支払いを記録しました",
  ],
  [
    "Payment was recorded for this cleaning.",
    "Se registró el pago de esta limpieza.",
    "O pagamento desta limpeza foi registrado.",
    "この清掃の支払いを記録しました。",
  ],
  [
    "useAuth must be used inside AuthProvider",
    "useAuth debe usarse dentro de AuthProvider",
    "useAuth deve ser usado dentro de AuthProvider",
    "useAuthはAuthProvider内で使用する必要があります",
  ],
  [
    "useI18n must be used inside I18nProvider",
    "useI18n debe usarse dentro de I18nProvider",
    "useI18n deve ser usado dentro de I18nProvider",
    "useI18nはI18nProvider内で使用する必要があります",
  ],
  [
    "useWorkspace must be used inside WorkspaceProvider",
    "useWorkspace debe usarse dentro de WorkspaceProvider",
    "useWorkspace deve ser usado dentro de WorkspaceProvider",
    "useWorkspaceはWorkspaceProvider内で使用する必要があります",
  ],
  [
    "{plan} supports up to {count} active clients",
    "{plan} admite hasta {count} clientes activos",
    "{plan} permite até {count} clientes ativos",
    "{plan}では有効な顧客を最大{count}件まで登録できます",
  ],
  [
    "{plan} supports up to {count} active team members",
    "{plan} admite hasta {count} miembros activos del equipo",
    "{plan} permite até {count} membros ativos da equipe",
    "{plan}では有効なチームメンバーを最大{count}名まで登録できます",
  ],
  [
    "A business plan is required before adding active records",
    "Se necesita un plan empresarial antes de agregar registros activos",
    "É necessário um plano empresarial antes de adicionar cadastros ativos",
    "有効な記録を追加するにはビジネスプランが必要です",
  ],
  [
    "A message can contain at most 6 attachments",
    "Un mensaje puede contener como máximo 6 archivos adjuntos",
    "Uma mensagem pode ter no máximo 6 anexos",
    "1件のメッセージに添付できるファイルは最大6件です",
  ],
  [
    "A message or attachment is required",
    "Se necesita un mensaje o archivo adjunto",
    "É necessário escrever uma mensagem ou anexar um arquivo",
    "メッセージまたは添付ファイルが必要です",
  ],
  [
    "A valid work email is required before creating an invitation",
    "Se necesita un correo laboral válido antes de crear una invitación",
    "É necessário um e-mail profissional válido antes de criar um convite",
    "招待を作成する前に有効な勤務先メールアドレスが必要です",
  ],
  [
    "A verified email is required to contact support",
    "Se necesita un correo verificado para contactar al soporte",
    "É necessário um e-mail verificado para contatar o suporte",
    "サポートへの問い合わせには確認済みメールアドレスが必要です",
  ],
  [
    "A verified sign-in email is required",
    "Se necesita un correo de inicio de sesión verificado",
    "É necessário um e-mail de login verificado",
    "確認済みのサインイン用メールアドレスが必要です",
  ],
  [
    "Activate this team member before sending an invitation",
    "Activa a este miembro del equipo antes de enviar una invitación",
    "Ative este membro da equipe antes de enviar um convite",
    "招待を送信する前に、このチームメンバーを有効にしてください",
  ],
  [
    "An audit reason is required",
    "Se necesita un motivo de auditoría",
    "É necessário informar um motivo para a auditoria",
    "監査理由が必要です",
  ],
  [
    "Attachment metadata must be an array",
    "Los metadatos de los archivos adjuntos deben ser una lista",
    "Os metadados dos anexos devem ser uma lista",
    "添付ファイルのメタデータは配列である必要があります",
  ],
  [
    "Authentication is required",
    "Se necesita autenticación",
    "É necessário estar autenticado",
    "認証が必要です",
  ],
  [
    "Business accounts cannot redeem client invitations",
    "Las cuentas de empresa no pueden aceptar invitaciones de cliente",
    "Contas empresariais não podem aceitar convites de cliente",
    "ビジネスアカウントでは顧客招待を利用できません",
  ],
  [
    "Check the subject and message length",
    "Revisa la longitud del asunto y del mensaje",
    "Verifique o tamanho do assunto e da mensagem",
    "件名とメッセージの長さを確認してください",
  ],
  [
    "Cleaning unavailable",
    "Limpieza no disponible",
    "Limpeza indisponível",
    "清掃を利用できません",
  ],
  [
    "Client not found or access denied",
    "No se encontró al cliente o se denegó el acceso",
    "Cliente não encontrado ou acesso negado",
    "顧客が見つからないか、アクセスが拒否されました",
  ],
  [
    "Complete or cancel the cleaning in progress before archiving this client",
    "Completa o cancela la limpieza en curso antes de archivar a este cliente",
    "Conclua ou cancele a limpeza em andamento antes de arquivar este cliente",
    "この顧客をアーカイブする前に、進行中の清掃を完了またはキャンセルしてください",
  ],
  [
    "Complete the cleaning before recording payment",
    "Completa la limpieza antes de registrar el pago",
    "Conclua a limpeza antes de registrar o pagamento",
    "支払いを記録する前に清掃を完了してください",
  ],
  [
    "Conversation unavailable",
    "Conversación no disponible",
    "Conversa indisponível",
    "会話を利用できません",
  ],
  [
    "Could not safely disambiguate employee membership upsert",
    "No se pudo actualizar de forma segura la membresía del empleado",
    "Não foi possível atualizar com segurança o vínculo do funcionário",
    "従業員メンバーシップを安全に更新できませんでした",
  ],
  [
    "Could not safely upgrade admin_list_organizations",
    "No se pudo actualizar admin_list_organizations de forma segura",
    "Não foi possível atualizar admin_list_organizations com segurança",
    "admin_list_organizationsを安全に更新できませんでした",
  ],
  [
    "Could not safely upgrade redeem_employee_invitation",
    "No se pudo actualizar redeem_employee_invitation de forma segura",
    "Não foi possível atualizar redeem_employee_invitation com segurança",
    "redeem_employee_invitationを安全に更新できませんでした",
  ],
  [
    "Could not safely upgrade send_chat_message",
    "No se pudo actualizar send_chat_message de forma segura",
    "Não foi possível atualizar send_chat_message com segurança",
    "send_chat_messageを安全に更新できませんでした",
  ],
  [
    "Employee accounts can only be linked through a verified invitation",
    "Las cuentas de empleados solo pueden vincularse mediante una invitación verificada",
    "Contas de funcionários só podem ser vinculadas por um convite verificado",
    "従業員アカウントは確認済みの招待からのみ連携できます",
  ],
  [
    "Invalid acceptance source",
    "Origen de aceptación no válido",
    "Origem de aceite inválida",
    "承認元が無効です",
  ],
  [
    "Invalid attachment metadata",
    "Metadatos del archivo adjunto no válidos",
    "Metadados do anexo inválidos",
    "添付ファイルのメタデータが無効です",
  ],
  [
    "Invalid client avatar path.",
    "La ruta de la foto del cliente no es válida.",
    "O caminho da foto do cliente é inválido.",
    "顧客画像のパスが無効です。",
  ],
  [
    "Invalid invitation code",
    "Código de invitación no válido",
    "Código de convite inválido",
    "招待コードが無効です",
  ],
  [
    "Invalid plan tier",
    "Nivel de plan no válido",
    "Nível de plano inválido",
    "プラン階層が無効です",
  ],
  [
    "Invalid support category",
    "Categoría de soporte no válida",
    "Categoria de suporte inválida",
    "サポートカテゴリーが無効です",
  ],
  [
    "Invalid team invitation code",
    "Código de invitación del equipo no válido",
    "Código de convite da equipe inválido",
    "チーム招待コードが無効です",
  ],
  [
    "Invalid ticket state",
    "Estado del ticket no válido",
    "Status do chamado inválido",
    "サポートチケットの状態が無効です",
  ],
  [
    "Invitation validity must be between 1 and 30 days",
    "La invitación debe ser válida entre 1 y 30 días",
    "A validade do convite deve ser de 1 a 30 dias",
    "招待の有効期間は1日から30日の間で指定してください",
  ],
  [
    "Manual access must be between 1 and 365 days",
    "El acceso manual debe durar entre 1 y 365 días",
    "O acesso manual deve durar de 1 a 365 dias",
    "手動アクセスは1日から365日の間で指定してください",
  ],
  [
    "Message is too long",
    "El mensaje es demasiado largo",
    "A mensagem é muito longa",
    "メッセージが長すぎます",
  ],
  [
    "No active client account link is available.",
    "No hay una conexión activa con la cuenta del cliente.",
    "Não há uma conexão ativa com a conta do cliente.",
    "有効な顧客アカウント連携がありません。",
  ],
  [
    "Only a confirmed or active cleaning can be completed",
    "Solo se puede completar una limpieza confirmada o en curso",
    "Somente uma limpeza confirmada ou em andamento pode ser concluída",
    "完了できるのは確定済みまたは進行中の清掃のみです",
  ],
  [
    "Only the business owner can accept the subscription agreement",
    "Solo el propietario puede aceptar el acuerdo de suscripción",
    "Somente o proprietário pode aceitar o contrato de assinatura",
    "サブスクリプション契約に同意できるのは事業オーナーのみです",
  ],
  [
    "Only the business owner can assign owner or manager roles",
    "Solo el propietario puede asignar funciones de propietario o gerente",
    "Somente o proprietário pode atribuir funções de proprietário ou gerente",
    "オーナーまたはマネージャーの役割を割り当てられるのは事業オーナーのみです",
  ],
  [
    "Only the business owner can change cleaning financials",
    "Solo el propietario puede cambiar los datos financieros de la limpieza",
    "Somente o proprietário pode alterar os dados financeiros da limpeza",
    "清掃の財務情報を変更できるのは事業オーナーのみです",
  ],
  [
    "Only the business owner can change client pricing",
    "Solo el propietario puede cambiar el precio del cliente",
    "Somente o proprietário pode alterar o preço do cliente",
    "顧客料金を変更できるのは事業オーナーのみです",
  ],
  [
    "Only the business owner can renew a recurring plan",
    "Solo el propietario puede renovar un plan recurrente",
    "Somente o proprietário pode renovar um plano recorrente",
    "定期プランを更新できるのは事業オーナーのみです",
  ],
  [
    "Only the business owner can set cleaning financials",
    "Solo el propietario puede definir los datos financieros de la limpieza",
    "Somente o proprietário pode definir os dados financeiros da limpeza",
    "清掃の財務情報を設定できるのは事業オーナーのみです",
  ],
  [
    "Only the business owner can set client pricing",
    "Solo el propietario puede definir el precio del cliente",
    "Somente o proprietário pode definir o preço do cliente",
    "顧客料金を設定できるのは事業オーナーのみです",
  ],
  [
    "Only the cleaning company can complete this job",
    "Solo la empresa de limpieza puede completar este trabajo",
    "Somente a empresa de limpeza pode concluir este serviço",
    "この作業を完了できるのは清掃会社のみです",
  ],
  [
    "Only the cleaning company can update payment status",
    "Solo la empresa de limpieza puede actualizar el estado del pago",
    "Somente a empresa de limpeza pode atualizar o status do pagamento",
    "支払い状況を更新できるのは清掃会社のみです",
  ],
  [
    "Only the owner can invite a manager",
    "Solo el propietario puede invitar a un gerente",
    "Somente o proprietário pode convidar um gerente",
    "マネージャーを招待できるのはオーナーのみです",
  ],
  [
    "Owner accounts do not use employee invitations",
    "Las cuentas de propietario no usan invitaciones de empleados",
    "Contas de proprietário não usam convites de funcionário",
    "オーナーアカウントでは従業員招待を使用しません",
  ],
  [
    "Recurring plan has no cleaning template",
    "El plan recurrente no tiene una plantilla de limpieza",
    "O plano recorrente não tem um modelo de limpeza",
    "定期プランに清掃テンプレートがありません",
  ],
  [
    "Recurring plan unavailable",
    "Plan recurrente no disponible",
    "Plano recorrente indisponível",
    "定期プランを利用できません",
  ],
  [
    "Renew this recurring plan before adding another month",
    "Renueva este plan recurrente antes de agregar otro mes",
    "Renove este plano recorrente antes de adicionar outro mês",
    "次の月を追加する前に、この定期プランを更新してください",
  ],
  [
    "Renewal opens seven days before the end of the covered month",
    "La renovación se habilita siete días antes del final del mes cubierto",
    "A renovação fica disponível sete dias antes do fim do mês coberto",
    "更新は対象月の終了7日前から利用できます",
  ],
  [
    "Restore this client before creating an invitation",
    "Restaura a este cliente antes de crear una invitación",
    "Restaure este cliente antes de criar um convite",
    "招待を作成する前に、この顧客を復元してください",
  ],
  [
    "Sign in with the invited work email: {email}",
    "Inicia sesión con el correo laboral invitado: {email}",
    "Entre com o e-mail profissional convidado: {email}",
    "招待された勤務先メールアドレスでサインインしてください：{email}",
  ],
  [
    "Support ticket not found",
    "No se encontró el ticket de soporte",
    "Chamado de suporte não encontrado",
    "サポートチケットが見つかりません",
  ],
  [
    "Team member not found or access denied",
    "No se encontró al miembro del equipo o se denegó el acceso",
    "Membro da equipe não encontrado ou acesso negado",
    "チームメンバーが見つからないか、アクセスが拒否されました",
  ],
  [
    "The client must accept the invitation before messaging",
    "El cliente debe aceptar la invitación antes de enviar mensajes",
    "O cliente precisa aceitar o convite antes de trocar mensagens",
    "メッセージを送るには、顧客が招待を承認する必要があります",
  ],
  [
    "This account is not connected to the conversation",
    "Esta cuenta no está conectada a la conversación",
    "Esta conta não está conectada à conversa",
    "このアカウントは会話に連携されていません",
  ],
  [
    "This agreement version is not active",
    "Esta versión del acuerdo no está activa",
    "Esta versão do contrato não está ativa",
    "この契約バージョンは有効ではありません",
  ],
  [
    "This business workspace needs an active plan",
    "Este espacio empresarial necesita un plan activo",
    "Este workspace empresarial precisa de um plano ativo",
    "このビジネスワークスペースには有効なプランが必要です",
  ],
  [
    "This client is already connected",
    "Este cliente ya está conectado",
    "Este cliente já está conectado",
    "この顧客はすでに連携済みです",
  ],
  [
    "This client record has been archived by the company",
    "La empresa archivó este registro de cliente",
    "Este cadastro de cliente foi arquivado pela empresa",
    "この顧客記録は会社によってアーカイブされています",
  ],
  [
    "This client record is already connected to another account",
    "Este registro de cliente ya está conectado a otra cuenta",
    "Este cadastro de cliente já está conectado a outra conta",
    "この顧客記録は別のアカウントに連携済みです",
  ],
  [
    "This invitation code has already been used",
    "Este código de invitación ya se usó",
    "Este código de convite já foi usado",
    "この招待コードはすでに使用されています",
  ],
  [
    "This invitation code is expired or no longer active",
    "Este código de invitación venció o ya no está activo",
    "Este código de convite expirou ou não está mais ativo",
    "この招待コードは期限切れか、無効になっています",
  ],
  [
    "This invitation was replaced after the team member changed",
    "Esta invitación fue reemplazada después de cambiar el miembro del equipo",
    "Este convite foi substituído após uma alteração no membro da equipe",
    "チームメンバーの変更後に、この招待は再発行されました",
  ],
  [
    "This sign-in already belongs to another business workspace",
    "Este inicio de sesión ya pertenece a otro espacio empresarial",
    "Este login já pertence a outro workspace empresarial",
    "このサインインはすでに別のビジネスワークスペースに所属しています",
  ],
  [
    "This team invitation has already been used",
    "Esta invitación del equipo ya se usó",
    "Este convite da equipe já foi usado",
    "このチーム招待はすでに使用されています",
  ],
  [
    "This team invitation is expired or no longer active",
    "Esta invitación del equipo venció o ya no está activa",
    "Este convite da equipe expirou ou não está mais ativo",
    "このチーム招待は期限切れか、無効になっています",
  ],
  [
    "This team member already has a linked account",
    "Este miembro del equipo ya tiene una cuenta vinculada",
    "Este membro da equipe já tem uma conta vinculada",
    "このチームメンバーにはすでに連携済みアカウントがあります",
  ],
  [
    "This team member is already linked to another account",
    "Este miembro del equipo ya está vinculado a otra cuenta",
    "Este membro da equipe já está vinculado a outra conta",
    "このチームメンバーはすでに別のアカウントに連携されています",
  ],
  [
    "This team member is no longer active",
    "Este miembro del equipo ya no está activo",
    "Este membro da equipe não está mais ativo",
    "このチームメンバーは現在無効です",
  ],
  [
    "Too many support requests. Please wait before trying again.",
    "Hay demasiadas solicitudes de soporte. Espera antes de intentarlo de nuevo.",
    "Há muitas solicitações de suporte. Aguarde antes de tentar novamente.",
    "サポート依頼が多すぎます。しばらく待ってからもう一度お試しください。",
  ],
  [
    "Uploaded attachment was not found",
    "No se encontró el archivo adjunto subido",
    "O anexo enviado não foi encontrado",
    "アップロード済みの添付ファイルが見つかりません",
  ],
  [
    "Use a separate work sign-in for a team member account",
    "Usa un inicio de sesión laboral separado para la cuenta del empleado",
    "Use um login profissional separado para a conta do funcionário",
    "チームメンバー用に別の勤務先アカウントでサインインしてください",
  ],
  [
    "Workspace not found or access denied",
    "No se encontró el espacio de trabajo o se denegó el acceso",
    "Workspace não encontrado ou acesso negado",
    "ワークスペースが見つからないか、アクセスが拒否されました",
  ],
  ["Owner", "Propietario", "Proprietário", "オーナー"],
  ["Manager", "Gerente", "Gerente", "マネージャー"],
  [
    "Scheduler",
    "Coordinador de agenda",
    "Coordenador de agenda",
    "スケジューラー",
  ],
  ["Cleaner", "Personal de limpieza", "Profissional de limpeza", "清掃担当"],
  ["Planned", "Planificada", "Planejada", "予定"],
  [
    "Needs business approval",
    "Necesita aprobación de la empresa",
    "Precisa da aprovação da empresa",
    "会社の承認待ち",
  ],
  [
    "Waiting for client",
    "Esperando al cliente",
    "Aguardando o cliente",
    "顧客の確認待ち",
  ],
  [
    "Client choosing a time",
    "El cliente está eligiendo un horario",
    "O cliente está escolhendo um horário",
    "顧客が日時を選択中",
  ],
  [
    "Review client choice",
    "Revisar elección del cliente",
    "Revisar escolha do cliente",
    "顧客の選択を確認",
  ],
  ["Draft", "Borrador", "Rascunho", "下書き"],
  ["Sent", "Enviada", "Enviada", "送信済み"],
  ["Overdue", "Vencida", "Vencida", "支払期限超過"],
  ["Cancelled", "Cancelada", "Cancelada", "キャンセル済み"],
  ["trialing", "En prueba", "Em teste", "トライアル中"],
  ["active", "Activo", "Ativo", "有効"],
  ["expired", "Vencido", "Expirado", "期限切れ"],
  ["grace_period", "Período de gracia", "Período de carência", "猶予期間"],
  ["missing", "Sin plan", "Sem plano", "プランなし"],
  ["none", "Ninguno", "Nenhum", "なし"],
  ["trial", "Prueba", "Teste", "トライアル"],
  ["beta", "Beta", "Beta", "ベータ"],
  ["app_store", "App Store", "App Store", "App Store"],
  ["manual", "Manual", "Manual", "手動"],
  ["No plan", "Sin plan", "Sem plano", "プランなし"],
  ["Low", "Baja", "Baixa", "低"],
  ["Normal", "Normal", "Normal", "通常"],
  ["High", "Alta", "Alta", "高"],
  ["Urgent", "Urgente", "Urgente", "緊急"],
  ["Open", "Abierto", "Aberto", "未対応"],
  [
    "Waiting on customer",
    "Esperando al cliente",
    "Aguardando o cliente",
    "顧客の返信待ち",
  ],
  ["Resolved", "Resuelto", "Resolvido", "解決済み"],
  ["Closed", "Cerrado", "Fechado", "クローズ済み"],
  ["Technical", "Técnico", "Técnico", "技術"],
  ["Billing", "Facturación", "Cobrança", "請求"],
  ["Feedback", "Comentarios", "Feedback", "フィードバック"],
  ["Failed", "Fallido", "Falhou", "失敗"],
  ["My work", "Mi trabajo", "Meu trabalho", "自分の仕事"],
  ["My schedule", "Mi agenda", "Minha agenda", "自分のスケジュール"],
  [
    "My assigned work",
    "Mi trabajo asignado",
    "Meus trabalhos atribuídos",
    "自分の担当作業",
  ],
  ["Assigned today", "Asignados hoy", "Atribuídos hoje", "本日の担当"],
  [
    "Your jobs only",
    "Solo tus trabajos",
    "Somente seus trabalhos",
    "自分の作業のみ",
  ],
  ["Remaining", "Pendientes", "Restantes", "残り"],
  [
    "Still open today",
    "Pendientes hoy",
    "Ainda pendentes hoje",
    "本日の未完了",
  ],
  ["Completed", "Completado", "Concluído", "完了"],
  ["Finished today", "Terminados hoy", "Concluídos hoje", "本日完了"],
  [
    "Assigned operations",
    "Operaciones asignadas",
    "Operações atribuídas",
    "担当業務",
  ],
  ["Today’s jobs", "Trabajos de hoy", "Trabalhos de hoje", "本日の作業"],
  [
    "No assigned cleanings today",
    "No tienes limpiezas asignadas hoy",
    "Nenhuma limpeza atribuída hoje",
    "本日担当の清掃はありません",
  ],
  [
    "Your upcoming assigned work remains available in My Schedule.",
    "Tus próximos trabajos asignados siguen disponibles en Mi agenda.",
    "Seus próximos trabalhos atribuídos continuam disponíveis em Minha agenda.",
    "今後の担当作業は「自分のスケジュール」で確認できます。",
  ],
  [
    "Assigned access",
    "Acceso asignado",
    "Acesso atribuído",
    "担当範囲のアクセス",
  ],
  [
    "Client directory, prices, payments, messages, team management, and schedule changes are available only to the business owner.",
    "El directorio de clientes, los precios, los pagos, los mensajes, la gestión del equipo y los cambios de agenda solo están disponibles para el propietario.",
    "A lista de clientes, preços, pagamentos, mensagens, gestão da equipe e alterações de agenda estão disponíveis somente para o proprietário.",
    "顧客一覧、料金、支払い、メッセージ、チーム管理、スケジュール変更は事業オーナーのみ利用できます。",
  ],
  ["Assigned work", "Trabajo asignado", "Trabalho atribuído", "担当作業"],
  [
    "View only the cleanings assigned to you. The business owner manages clients and schedule changes.",
    "Consulta solo las limpiezas que tienes asignadas. El propietario gestiona los clientes y los cambios de agenda.",
    "Veja somente as limpezas atribuídas a você. O proprietário gerencia clientes e alterações de agenda.",
    "自分に割り当てられた清掃だけを確認できます。顧客とスケジュール変更は事業オーナーが管理します。",
  ],
  [
    "No assigned work",
    "No hay trabajo asignado",
    "Nenhum trabalho atribuído",
    "担当作業はありません",
  ],
  [
    "No cleaning is assigned to you on this date.",
    "No tienes ninguna limpieza asignada en esta fecha.",
    "Nenhuma limpeza foi atribuída a você nesta data.",
    "この日に割り当てられた清掃はありません。",
  ],
  [
    "The business owner manages the company identity and logo.",
    "El propietario gestiona la identidad y el logotipo de la empresa.",
    "O proprietário gerencia a identidade e o logotipo da empresa.",
    "会社情報とロゴは事業オーナーが管理します。",
  ],
  [
    "Only jobs assigned to you at {business} appear here.",
    "Aquí solo aparecen los trabajos que tienes asignados en {business}.",
    "Somente os trabalhos atribuídos a você na {business} aparecem aqui.",
    "{business}で自分に割り当てられた作業だけがここに表示されます。",
  ],
  [
    "Your assigned cleaning work at a glance.",
    "Tus trabajos de limpieza asignados de un vistazo.",
    "Seus trabalhos de limpeza atribuídos em um só lugar.",
    "自分に割り当てられた清掃作業をひと目で確認できます。",
  ],
  [
    "Only the business owner can record payment",
    "Solo el propietario puede registrar el pago",
    "Somente o proprietário pode registrar o pagamento",
    "支払いを記録できるのは事業オーナーのみです",
  ],
  [
    "Only the business owner can update payment status",
    "Solo el propietario puede actualizar el estado del pago",
    "Somente o proprietário pode atualizar o status do pagamento",
    "支払い状態を更新できるのは事業オーナーのみです",
  ],
  [
    "Only the owner or an assigned cleaner can complete this job",
    "Solo el propietario o un empleado asignado puede completar este trabajo",
    "Somente o proprietário ou um funcionário atribuído pode concluir este trabalho",
    "この作業を完了できるのはオーナーまたは担当スタッフのみです",
  ],
  [
    "Message author does not match the signed-in account",
    "El autor del mensaje no coincide con la cuenta conectada",
    "O autor da mensagem não corresponde à conta conectada",
    "メッセージの送信者がサインイン中のアカウントと一致しません",
  ],
  [
    "Only the business owner can complete this job",
    "Solo el propietario puede completar este trabajo",
    "Somente o proprietário pode concluir este trabalho",
    "この作業を完了できるのは事業オーナーのみです",
  ],
  [
    "Only the business owner can create this system message",
    "Solo el propietario puede crear este mensaje del sistema",
    "Somente o proprietário pode criar esta mensagem do sistema",
    "このシステムメッセージを作成できるのは事業オーナーのみです",
  ],
  [
    "Only the business owner can message clients",
    "Solo el propietario puede enviar mensajes a los clientes",
    "Somente o proprietário pode enviar mensagens aos clientes",
    "顧客にメッセージを送信できるのは事業オーナーのみです",
  ],
  ["/ month", "/ mes", "/ mês", "/月"],
  ["/ year", "/ año", "/ ano", "/年"],
  [
    "About {price} per month · Save {percent}%",
    "Aproximadamente {price} al mes · Ahorra {percent}%",
    "Cerca de {price} por mês · Economize {percent}%",
    "月額換算約{price}・{percent}%お得",
  ],
  [
    "Access continues through {date}; renewal is turned off.",
    "El acceso continúa hasta el {date}; la renovación está desactivada.",
    "O acesso continua até {date}; a renovação está desativada.",
    "{date}まで利用できます。更新はオフです。",
  ],
  [
    "Annual · Save about 20%",
    "Anual · Ahorra cerca del 20%",
    "Anual · Economize cerca de 20%",
    "年払い・約20%お得",
  ],
  ["Billing cycle", "Ciclo de facturación", "Ciclo de cobrança", "請求周期"],
  [
    "Change in billing portal",
    "Cambiar en el portal de facturación",
    "Alterar no portal de cobrança",
    "請求ポータルで変更",
  ],
  [
    "Upgrade plan",
    "Mejorar plan",
    "Fazer upgrade do plano",
    "プランをアップグレード",
  ],
  [
    "Downgrade plan",
    "Cambiar a un plan inferior",
    "Fazer downgrade do plano",
    "下位プランへ変更",
  ],
  ["Switch to annual", "Cambiar a anual", "Mudar para anual", "年払いに変更"],
  [
    "Switch to monthly",
    "Cambiar a mensual",
    "Mudar para mensal",
    "月払いに変更",
  ],
  [
    "Opening secure plan change…",
    "Abriendo el cambio seguro de plan…",
    "Abrindo a alteração segura do plano…",
    "安全なプラン変更を開いています…",
  ],
  [
    "Plan change confirmed. We are refreshing your access.",
    "Cambio de plan confirmado. Estamos actualizando tu acceso.",
    "Alteração de plano confirmada. Estamos atualizando seu acesso.",
    "プラン変更が確認されました。アクセス情報を更新しています。",
  ],
  [
    "Change with Apple",
    "Cambiar con Apple",
    "Alterar com a Apple",
    "Appleで変更",
  ],
  [
    "Checkout was canceled. Your current access was not changed.",
    "El pago se canceló. Tu acceso actual no cambió.",
    "O checkout foi cancelado. Seu acesso atual não mudou.",
    "購入手続きはキャンセルされました。現在のアクセスに変更はありません。",
  ],
  [
    "Choose a plan to activate your company workspace.",
    "Elige un plan para activar el espacio de tu empresa.",
    "Escolha um plano para ativar o workspace da sua empresa.",
    "会社のワークスペースを有効にするプランを選択してください。",
  ],
  ["Choose plan", "Elegir plan", "Escolher plano", "プランを選択"],
  [
    "Current Apple plan",
    "Plan actual de Apple",
    "Plano Apple atual",
    "現在のAppleプラン",
  ],
  [
    "Current plan · Manage",
    "Plan actual · Administrar",
    "Plano atual · Gerenciar",
    "現在のプラン・管理",
  ],
  [
    "Every business plan includes scheduling, confirmations, in-app client communication, invoices, and access on iPhone, iPad, and web. Client accounts are always free.",
    "Todos los planes empresariales incluyen agenda, confirmaciones, comunicación con clientes dentro de la app, facturas y acceso en iPhone, iPad y web. Las cuentas de clientes siempre son gratis.",
    "Todos os planos empresariais incluem agenda, confirmações, comunicação com clientes dentro do app, faturas e acesso no iPhone, iPad e web. Contas de clientes são sempre gratuitas.",
    "すべてのビジネスプランに、スケジュール、確認、アプリ内顧客連絡、請求書、iPhone・iPad・Webアクセスが含まれます。顧客アカウントは常に無料です。",
  ],
  [
    "I agree to the Business Subscription Agreement",
    "Acepto el Acuerdo de suscripción empresarial",
    "Concordo com o Contrato de Assinatura Empresarial",
    "ビジネスサブスクリプション契約に同意します",
  ],
  [
    "Manage billing",
    "Administrar facturación",
    "Gerenciar cobrança",
    "請求を管理",
  ],
  [
    "Manage with Apple",
    "Administrar con Apple",
    "Gerenciar com a Apple",
    "Appleで管理",
  ],
  ["Most popular", "Más popular", "Mais popular", "一番人気"],
  [
    "Opening secure checkout…",
    "Abriendo el pago seguro…",
    "Abrindo o checkout seguro…",
    "安全な購入画面を開いています…",
  ],
  ["Opening…", "Abriendo…", "Abrindo…", "開いています…"],
  [
    "Payment received. We are confirming your subscription securely.",
    "Pago recibido. Estamos confirmando tu suscripción de forma segura.",
    "Pagamento recebido. Estamos confirmando sua assinatura com segurança.",
    "お支払いを受け付けました。サブスクリプションを安全に確認しています。",
  ],
  [
    "Plan required",
    "Se requiere un plan",
    "Plano necessário",
    "プランが必要です",
  ],
  [
    "Plans & billing",
    "Planes y facturación",
    "Planos e cobrança",
    "プランと請求",
  ],
  [
    "Required before secure checkout opens.",
    "Obligatorio antes de abrir el pago seguro.",
    "Obrigatório antes de abrir o checkout seguro.",
    "安全な購入画面を開く前に必要です。",
  ],
  [
    "Secure billing portal did not return a valid link",
    "El portal de facturación seguro no devolvió un enlace válido",
    "O portal seguro de cobrança não retornou um link válido",
    "安全な請求ポータルから有効なリンクが返されませんでした",
  ],
  [
    "Secure checkout did not return a valid link",
    "El pago seguro no devolvió un enlace válido",
    "O checkout seguro não retornou um link válido",
    "安全な購入画面から有効なリンクが返されませんでした",
  ],
  [
    "Simple plans that grow with your team",
    "Planes simples que crecen con tu equipo",
    "Planos simples que crescem com sua equipe",
    "チームの成長に合わせたシンプルなプラン",
  ],
  [
    "Subscribe before the trial ends",
    "Suscríbete antes de que termine la prueba",
    "Assine antes do fim do período gratuito",
    "無料期間終了前に登録できます",
  ],
  ["Subscribe now", "Suscribirme ahora", "Assinar agora", "今すぐ登録"],
  [
    "Subscription Agreement",
    "Acuerdo de suscripción",
    "Contrato de Assinatura",
    "サブスクリプション契約",
  ],
  [
    "The business owner counts toward the team limit.",
    "El propietario cuenta para el límite del equipo.",
    "O proprietário conta no limite da equipe.",
    "事業オーナーもチーム上限に含まれます。",
  ],
  [
    "The current billing period renews after {date}.",
    "El período actual se renueva después del {date}.",
    "O período de cobrança atual renova após {date}.",
    "現在の請求期間は{date}以降に更新されます。",
  ],
  [
    "This workspace exceeds this plan’s capacity. Archive clients or deactivate team members first.",
    "Este espacio supera la capacidad del plan. Primero archiva clientes o desactiva miembros del equipo.",
    "Este workspace excede a capacidade do plano. Primeiro arquive clientes ou desative membros da equipe.",
    "このワークスペースはプラン上限を超えています。先に顧客をアーカイブするか、チームメンバーを無効にしてください。",
  ],
  [
    "Unlimited active clients",
    "Clientes activos ilimitados",
    "Clientes ativos ilimitados",
    "有効顧客数無制限",
  ],
  [
    "Up to {count} active clients",
    "Hasta {count} clientes activos",
    "Até {count} clientes ativos",
    "有効顧客{count}件まで",
  ],
  [
    "Up to {count} active team members",
    "Hasta {count} miembros activos del equipo",
    "Até {count} membros ativos da equipe",
    "有効チームメンバー{count}人まで",
  ],
  [
    "View plans & billing",
    "Ver planes y facturación",
    "Ver planos e cobrança",
    "プランと請求を表示",
  ],
  [
    "Web billing starts immediately when checkout succeeds; unused complimentary days are not added to the paid period.",
    "La facturación web comienza en cuanto se completa el pago; los días gratuitos no usados no se agregan al período pagado.",
    "A cobrança web começa assim que o checkout é concluído; os dias gratuitos não usados não são adicionados ao período pago.",
    "Web請求は購入完了時に直ちに始まり、未使用の無料日数は有料期間に加算されません。",
  ],
  [
    "Website subscriptions are processed securely by Square. iPhone subscriptions are processed by Apple. Only one billing provider can be active for a workspace, and TidyPing never collects client cleaning payments.",
    "Las suscripciones del sitio se procesan de forma segura con Square y las del iPhone con Apple. Solo un proveedor de facturación puede estar activo por espacio, y TidyPing nunca cobra los pagos de limpieza de los clientes.",
    "Assinaturas do site são processadas com segurança pela Square e assinaturas do iPhone pela Apple. Somente um provedor de cobrança pode ficar ativo por workspace, e o TidyPing nunca recebe pagamentos de faxina dos clientes.",
    "WebサイトのサブスクリプションはSquare、iPhoneのサブスクリプションはAppleが安全に処理します。1つのワークスペースで有効にできる請求事業者は1社のみで、TidyPingが顧客の清掃料金を回収することはありません。",
  ],
  [
    "You can subscribe before complimentary access ends.",
    "Puedes suscribirte antes de que termine el acceso gratuito.",
    "Você pode assinar antes do fim do acesso gratuito.",
    "無料アクセス終了前でも登録できます。",
  ],
  [
    "Your complimentary access is active.",
    "Tu acceso gratuito está activo.",
    "Seu acesso gratuito está ativo.",
    "無料アクセスは有効です。",
  ],
  [
    "Your free access continues through {date}.",
    "Tu acceso gratuito continúa hasta el {date}.",
    "Seu acesso gratuito continua até {date}.",
    "無料アクセスは{date}まで続きます。",
  ],
  [
    "For solo owners and small cleaning teams",
    "Para propietarios independientes y equipos pequeños de limpieza",
    "Para proprietários autônomos e pequenas equipes de limpeza",
    "個人オーナーと小規模清掃チーム向け",
  ],
  [
    "For growing companies coordinating a larger team",
    "Para empresas en crecimiento que coordinan un equipo mayor",
    "Para empresas em crescimento que coordenam uma equipe maior",
    "より大きなチームを管理する成長企業向け",
  ],
  [
    "For established operations with high client volume",
    "Para operaciones consolidadas con gran volumen de clientes",
    "Para operações consolidadas com alto volume de clientes",
    "顧客数の多い確立した事業向け",
  ],
  [
    "Scheduling and two-sided confirmations",
    "Agenda y confirmaciones de ambas partes",
    "Agenda e confirmações das duas partes",
    "スケジュールと双方確認",
  ],
  [
    "In-app client chat with photo and video attachments",
    "Chat con clientes dentro de la app con fotos y videos",
    "Chat com clientes dentro do app com fotos e vídeos",
    "写真・動画添付対応のアプリ内顧客チャット",
  ],
  [
    "Invoices and owner-only finance reports",
    "Facturas e informes financieros exclusivos para el propietario",
    "Faturas e relatórios financeiros exclusivos do proprietário",
    "オーナー限定の請求書と財務レポート",
  ],
  [
    "iPhone, iPad, and web access",
    "Acceso en iPhone, iPad y web",
    "Acesso no iPhone, iPad e web",
    "iPhone・iPad・Webアクセス",
  ],
  [
    "Everything in Starter",
    "Todo lo incluido en Starter",
    "Tudo do Starter",
    "Starterの全機能",
  ],
  [
    "Team roles and cleaning assignments",
    "Roles de equipo y asignaciones de limpieza",
    "Funções da equipe e atribuições de limpeza",
    "チーム権限と清掃担当割り当て",
  ],
  [
    "Scheduling, chat, invoices, and owner finance tools",
    "Agenda, chat, facturas y herramientas financieras del propietario",
    "Agenda, chat, faturas e ferramentas financeiras do proprietário",
    "スケジュール、チャット、請求書、オーナー向け財務ツール",
  ],
  [
    "Everything in Growth",
    "Todo lo incluido en Growth",
    "Tudo do Growth",
    "Growthの全機能",
  ],
  [
    "Capacity for established cleaning operations",
    "Capacidad para operaciones de limpieza consolidadas",
    "Capacidade para operações de limpeza consolidadas",
    "確立した清掃事業向けの容量",
  ],
  ["square", "Square", "Square", "Square"],
  [
    "Web billing is not configured yet",
    "La facturación web aún no está configurada",
    "A cobrança web ainda não está configurada",
    "Web請求はまだ設定されていません",
  ],
  [
    "Unable to start secure checkout",
    "No se pudo iniciar el pago seguro",
    "Não foi possível iniciar o checkout seguro",
    "安全な購入手続きを開始できませんでした",
  ],
  [
    "Unable to open the secure billing portal",
    "No se pudo abrir el portal de facturación seguro",
    "Não foi possível abrir o portal seguro de cobrança",
    "安全な請求ポータルを開けませんでした",
  ],
  [
    "This workspace is billed by Apple. Manage or cancel it with Apple before starting web billing.",
    "Este espacio se factura con Apple. Administra o cancela esa suscripción con Apple antes de iniciar la facturación web.",
    "Este workspace é cobrado pela Apple. Gerencie ou cancele essa assinatura com a Apple antes de iniciar a cobrança web.",
    "このワークスペースはApple請求です。Web請求を始める前にAppleで管理またはキャンセルしてください。",
  ],
  [
    "This workspace already has web billing. Change its plan from TidyPing billing settings.",
    "Este espacio ya tiene facturación web. Cambia el plan desde la configuración de facturación de TidyPing.",
    "Este workspace já tem cobrança web. Altere o plano nas configurações de cobrança do TidyPing.",
    "このワークスペースにはすでにWeb請求があります。TidyPingの請求設定からプランを変更してください。",
  ],
  [
    "We are securely confirming your Square payment.",
    "Estamos confirmando de forma segura tu pago de Square.",
    "Estamos confirmando seu pagamento da Square com segurança.",
    "Squareのお支払いを安全に確認しています。",
  ],
  [
    "Payment confirmed. Your subscription is active.",
    "Pago confirmado. Tu suscripción está activa.",
    "Pagamento confirmado. Sua assinatura está ativa.",
    "お支払いを確認しました。サブスクリプションは有効です。",
  ],
  [
    "Square could not confirm this payment. Your existing access was not changed.",
    "Square no pudo confirmar este pago. Tu acceso actual no cambió.",
    "A Square não conseguiu confirmar este pagamento. Seu acesso atual não foi alterado.",
    "Squareでこのお支払いを確認できませんでした。現在のアクセスに変更はありません。",
  ],
  [
    "Square is still processing the payment. Your plan will update automatically.",
    "Square aún está procesando el pago. Tu plan se actualizará automáticamente.",
    "A Square ainda está processando o pagamento. Seu plano será atualizado automaticamente.",
    "Squareがお支払いを処理中です。プランは自動的に更新されます。",
  ],
  [
    "Plan change scheduled for {date}.",
    "Cambio de plan programado para el {date}.",
    "Alteração de plano agendada para {date}.",
    "プラン変更は{date}に予定されています。",
  ],
  [
    "Plan change scheduled for the next billing cycle.",
    "Cambio de plan programado para el próximo ciclo de facturación.",
    "Alteração de plano agendada para o próximo ciclo de cobrança.",
    "次回の請求周期にプラン変更が予定されています。",
  ],
  [
    "Scheduling plan change…",
    "Programando cambio de plan…",
    "Agendando alteração de plano…",
    "プラン変更を予約しています…",
  ],
  [
    "Cancel renewal",
    "Cancelar renovación",
    "Cancelar renovação",
    "更新をキャンセル",
  ],
  [
    "Renewal canceled",
    "Renovación cancelada",
    "Renovação cancelada",
    "更新キャンセル済み",
  ],
  ["Updating…", "Actualizando…", "Atualizando…", "更新しています…"],
  [
    "Cancel renewal at the end of the current billing period? Your access will continue until then.",
    "¿Cancelar la renovación al final del período actual? Tu acceso continuará hasta entonces.",
    "Cancelar a renovação no fim do período atual? Seu acesso continuará até lá.",
    "現在の請求期間の終了時に更新をキャンセルしますか？それまでは利用できます。",
  ],
  [
    "Renewal canceled. Access continues through {date}.",
    "Renovación cancelada. El acceso continúa hasta el {date}.",
    "Renovação cancelada. O acesso continua até {date}.",
    "更新をキャンセルしました。{date}まで利用できます。",
  ],
  [
    "Renewal canceled. Access continues through the current billing period.",
    "Renovación cancelada. El acceso continúa durante el período actual.",
    "Renovação cancelada. O acesso continua durante o período de cobrança atual.",
    "更新をキャンセルしました。現在の請求期間中は利用できます。",
  ],
  [
    "Unable to update web billing",
    "No se pudo actualizar la facturación web",
    "Não foi possível atualizar a cobrança web",
    "Web請求を更新できませんでした",
  ],
  [
    "Unable to confirm the Square checkout",
    "No se pudo confirmar el pago de Square",
    "Não foi possível confirmar o checkout da Square",
    "Squareの購入手続きを確認できませんでした",
  ],
  [
    "Only the business owner can manage billing",
    "Solo el propietario puede administrar la facturación",
    "Somente o proprietário pode gerenciar a cobrança",
    "請求を管理できるのは事業オーナーのみです",
  ],
  [
    "Accept the subscription agreement first",
    "Primero acepta el acuerdo de suscripción",
    "Primeiro aceite o contrato de assinatura",
    "先にサブスクリプション契約に同意してください",
  ],
  [
    "Unable to update billing",
    "No se pudo actualizar la facturación",
    "Não foi possível atualizar a cobrança",
    "請求を更新できませんでした",
  ],
  [
    "Automatic renewal is active again.",
    "La renovación automática está activa de nuevo.",
    "A renovação automática está ativa novamente.",
    "自動更新が再び有効になりました。",
  ],
  [
    "Keep subscription",
    "Mantener suscripción",
    "Manter assinatura",
    "サブスクリプションを継続",
  ],
  [
    "Change to {plan} ({cycle}) is scheduled for {date}.",
    "El cambio a {plan} ({cycle}) está programado para el {date}.",
    "A alteração para {plan} ({cycle}) está agendada para {date}.",
    "{plan}（{cycle}）への変更は{date}に予定されています。",
  ],
  [
    "Change to {plan} ({cycle}) is scheduled for the next billing cycle.",
    "El cambio a {plan} ({cycle}) está programado para el próximo ciclo.",
    "A alteração para {plan} ({cycle}) está agendada para o próximo ciclo.",
    "{plan}（{cycle}）への変更は次回の請求周期に予定されています。",
  ],
  ["Scheduled change", "Cambio programado", "Alteração agendada", "変更予定"],
  [
    "Keep subscription to change plans",
    "Mantén la suscripción para cambiar de plan",
    "Mantenha a assinatura para alterar o plano",
    "プランを変更するにはサブスクリプションを継続してください",
  ],
  [
    "Keep the subscription before changing plans",
    "Mantén la suscripción antes de cambiar de plan",
    "Mantenha a assinatura antes de alterar o plano",
    "プランを変更する前にサブスクリプションを継続してください",
  ],
  [
    "Review your subscription",
    "Revisa tu suscripción",
    "Revise sua assinatura",
    "サブスクリプションを確認",
  ],
  [
    "Square will show the final amount before you confirm.",
    "Square mostrará el importe final antes de que confirmes.",
    "A Square mostrará o valor final antes de você confirmar.",
    "確定前にSquareが最終金額を表示します。",
  ],
  [
    "Continue to secure checkout",
    "Continuar al pago seguro",
    "Continuar para o checkout seguro",
    "安全な購入手続きへ進む",
  ],
  ["Remote configuration", "Configuración remota", "Configuração remota", "リモート設定"],
  ["Plan catalog", "Catálogo de planes", "Catálogo de planos", "プランカタログ"],
  ["{count} plans", "{count} planes", "{count} planos", "{count}プラン"],
  [
    "Copy, limits, ordering, and reference prices publish without an app update. Apple and Square remain authoritative for the amount charged, so provider prices must match before publishing a price change.",
    "Los textos, límites, orden y precios de referencia se publican sin actualizar la app. Apple y Square determinan el importe cobrado, por lo que los precios del proveedor deben coincidir antes de publicar un cambio.",
    "Textos, limites, ordem e preços de referência são publicados sem atualizar o app. Apple e Square continuam sendo a fonte oficial do valor cobrado, então os preços do provedor devem coincidir antes da publicação.",
    "説明、上限、並び順、参考価格はアプリ更新なしで公開できます。請求額はAppleとSquareが正式な基準となるため、価格変更前にプロバイダー側と一致させてください。",
  ],
  ["Enabled", "Activo", "Ativo", "有効"],
  [
    "Monthly reference price (USD)",
    "Precio mensual de referencia (USD)",
    "Preço mensal de referência (USD)",
    "月額参考価格（USD）",
  ],
  [
    "Annual reference price (USD)",
    "Precio anual de referencia (USD)",
    "Preço anual de referência (USD)",
    "年額参考価格（USD）",
  ],
  ["Team limit", "Límite del equipo", "Limite da equipe", "チーム上限"],
  ["Client limit", "Límite de clientes", "Limite de clientes", "顧客上限"],
  ["Display order", "Orden de visualización", "Ordem de exibição", "表示順"],
  ["Plan description", "Descripción del plan", "Descrição do plano", "プラン説明"],
  [
    "Features (one per line)",
    "Funciones (una por línea)",
    "Recursos (um por linha)",
    "機能（1行に1つ）",
  ],
  ["Publishing…", "Publicando…", "Publicando…", "公開中…"],
  ["Publish plan", "Publicar plan", "Publicar plano", "プランを公開"],
  [
    "Plan catalog published.",
    "Catálogo de planes publicado.",
    "Catálogo de planos publicado.",
    "プランカタログを公開しました。",
  ],
  ["Unlimited", "Ilimitado", "Ilimitado", "無制限"],
  [
    "All supported plan localizations are required",
    "Se requieren todas las traducciones compatibles del plan",
    "Todas as traduções compatíveis do plano são obrigatórias",
    "対応するすべてのプラン翻訳が必要です",
  ],
  [
    "Each language needs between 1 and 12 plan features",
    "Cada idioma necesita entre 1 y 12 funciones del plan",
    "Cada idioma precisa de 1 a 12 recursos do plano",
    "各言語に1〜12個のプラン機能が必要です",
  ],
  ["Invalid display order", "Orden de visualización no válido", "Ordem de exibição inválida", "表示順が無効です"],
  ["Invalid plan capacity", "Capacidad del plan no válida", "Capacidade do plano inválida", "プラン上限が無効です"],
  ["Invalid reference pricing", "Precio de referencia no válido", "Preço de referência inválido", "参考価格が無効です"],
  ["Plan not found", "Plan no encontrado", "Plano não encontrado", "プランが見つかりません"],
  [
    "The assigned business plan is not available",
    "El plan empresarial asignado no está disponible",
    "O plano empresarial atribuído não está disponível",
    "割り当てられたビジネスプランは利用できません",
  ],
] as const;
